import PropTypes from 'prop-types';
import classnames from 'classnames';

import { SeoLink } from 'dibs-seo/exports/SeoLink.tsx';
import { ALWAYS_LINKABLE_LINK } from 'dibs-elements/exports/SeoLink.tsx';

import styles from './ContemporaryLandingStyleRowItem.scss';
import { trackEvent } from 'dibs-tracking';

const trackClick = item => {
    trackEvent({
        action: 'featured collection',
        category: 'contemporary landing page interaction',
        label: `collection clicked|${item.title}`,
    });
};

export const ContemporaryLandingStyleRowItem = ({ item, rowIndex }) => {
    if (!item) {
        return null;
    }

    const { imagePath, title, cta, description } = item;
    const wrapperClasses = classnames('colXs12 colLg4', styles.rowItem, {
        [styles.firstRow]: rowIndex === 0,
    });

    return (
        <SeoLink
            variant={ALWAYS_LINKABLE_LINK}
            className={wrapperClasses}
            onClick={() => trackClick(item)}
            linkData={item.linkData}
        >
            <div className="rowFlex">
                <div className="colXs6 colLg12">
                    <div className={styles.imageWrapper}>
                        {imagePath ? (
                            <img className={styles.image} src={imagePath} alt={title} />
                        ) : (
                            <div className={styles.imagePlaceholder} />
                        )}
                    </div>
                </div>
                <div className="colXs6 colLg12">
                    <h2 className={styles.title}>{title}</h2>
                    {cta && <p className={styles.cta}>{cta}</p>}
                    {description && <p className={styles.text}>{description}</p>}
                </div>
            </div>
        </SeoLink>
    );
};

ContemporaryLandingStyleRowItem.propTypes = {
    item: PropTypes.object,
    rowIndex: PropTypes.number.isRequired,
};
